import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IPublishDraftJobPostPayload } from '../types';

export const publishDraftJobPost = async (
  id: string,
  payload: IPublishDraftJobPostPayload,
): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.post(
    `/posting-service/postings/${id}/publish`,
    payload,
    { headers },
  );
};
